module.exports = __webpack_public_path__ + "public/Icons/home_page_settings.svg?a9a02a2b";